import React from 'react'

const TitleBar = () => {
  return (
    <>
    <div className='title-bar'>
        <h1>Desi-Italiano</h1>
        <i class="fa-solid fa-cart-shopping fa-shake"></i>
    </div>
    <div className='hero-section'>
        <div className='grid grid-two-column'>
            <div className='welcome-title'>
                <h1>Welcome to <span>Desi-Italiano</span> Ristorante' Menu</h1>
                <p className='welcome-info'>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Omnis dolorum, velit sequi expedita fuga excepturi alias. Molestiae aut fuga corrupti suscipit a architecto asperiores quia et, veritatis possimus qui laboriosam eum dicta, omnis sit saepe non eligendi provident labore illo!</p>
                <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nemo repellendus, repellat blanditiis hic dolor doloribus laboriosam consequatur quasi eligendi libero, commodi cumque quos odio eius impedit consectetur nam veritatis? Esse?</p>
            </div>
            <div className='restaurant-img'>
                <img src="./images/restaurantImage.jpg" alt="restaurantImg"/>
            </div>
        </div>
    </div>
    <div className='arrow-down'>
        <i class="fa-solid fa-circle-chevron-down fa-bounce"></i>
        <p>Click to see the menu...</p>
    </div>
    </>
  )
}

export default TitleBar